import React from 'react';
import { Box, Typography, LinearProgress, CircularProgress, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface SetupLoadingScreenProps {
  progress: number;
  currentStep: string;
}

const SetupLoadingScreen: React.FC<SetupLoadingScreenProps> = ({ progress, currentStep }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        zIndex: 9999,
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 3,
            p: 4,
          }}
        >
          <CircularProgress size={60} thickness={4} />

          <Typography variant="h5" sx={{ textAlign: 'center', fontWeight: 'medium' }}>
            {t('setup.oneMoment')}
          </Typography>

          <Box sx={{ width: '100%', mt: 2 }}>
            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{
                height: 8,
                borderRadius: 4,
                bgcolor: 'action.disabledBackground',
                '& .MuiLinearProgress-bar': {
                  borderRadius: 4,
                },
              }}
            />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1, textAlign: 'center' }}>
              {t(`setup.progress.${currentStep}`, { defaultValue: t('setup.progress.Preparing') })}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mt: 0.5, textAlign: 'center', display: 'block' }}
            >
              {Math.round(progress)}%
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default SetupLoadingScreen;
